import Resource from './Resource';

export default class DistrictImage extends Resource {
	constructor(options={}) {
		let {
			route = 'district',
		} = options;

		let config = {
			route: route
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
